import "./widgetChart";
import "./widgetKPIAffaires";
import "./widgetKPILeads";
import "./widgetKPIContracts";
import "./widgetKPICalls";
import "./widgetKPICases";
